module.exports = __webpack_public_path__ + "static/media/Test44.8d3c3baf.bmp";